"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("./Button");
var _Icon = require("../Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoadingButton = _ref => {
  let {
    children,
    loading = true,
    icon = /*#__PURE__*/_react.default.createElement(_Icon.Throbber, {
      className: "mx-auto",
      role: "status",
      "aria-label": "loading",
      "aria-live": "polite"
    }),
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Button.Button, props, loading ? icon : children);
};
exports.LoadingButton = LoadingButton;
LoadingButton.displayName = "LoadingButton";